import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { GrStack, palette } from "@jnpmedi/grebob";
import { pinAttrSign } from "@assets/styles/animations";

export const StyledTokenView = styled.div`
  > .fx-guard.--loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
    opacity: 1;
  }

  > .fx-guard > .fx-guard-error {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 20vh;
  }

  h1 {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    font-size: 1.25rem;
    word-break: keep-all;
  }

  h2 {
    margin: 10px 0 20px 0;
    padding: 0;
    font-weight: normal;
    font-size: 0.82rem;
    word-break: keep-all;
  }
`;

export const StyledTokenViewVerifyStack = styled(GrStack)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 70vh;
`;

export const StyledTokenViewVerifyInnerStack = styled(GrStack)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
  padding: 40px;
  background: #fff;
  box-shadow: 0 0.2rem 0.3rem rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  border: 1px solid ${palette["grey025"]};

  @media (max-width: 450px) {
    padding: 30px;
  }
`;

export const StyledSignIndicator = css`
  content: attr(data-label);
  position: absolute;
  top: 50%;
  left: -94%;
  margin-top: -12px;
  width: 76px;
  height: 24px;
  color: ${palette["white"]};
  background-color: ${palette["maven-blue-dark"]};
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%);
  text-align: center;
  animation: ${pinAttrSign} 1.6s ease-in-out infinite;
  white-space: nowrap;
  text-indent: -10px;
  pointer-events: none;
  line-height: 24px;
  cursor: default;
  opacity: 0.85;
  z-index: 10;
`;
